export default __webpack_public_path__ + "static/media/yellow2.3374ca42.png";